import { styled } from "@mui/material";

export const Form = styled("form")(() => ({
  width: "100%",
}));
